import { Pencil, Plus } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { IJobVendor } from 'jobs/types';
import { Color } from 'theme/enums';

import { UpsertVendor } from './UpsertVendor';

interface IProps {
  jobId: number;
  projectId: number;
  vendor?: IJobVendor;
  buttonElement?: ReactElement;
}

export const UpsertVendorButton = ({ jobId, projectId, vendor, buttonElement }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const onClose = () => {
    setIsOpen(false);
  };

  const button = buttonElement ? (
    cloneElement(buttonElement, {
      onClick: () => setIsOpen(true),
    })
  ) : (
    <Button
      text={vendor ? t('buttonLabelEditVendor') : t('buttonLabelAddVendor')}
      color={Color.SUCCESS}
      startDecorator={vendor ? <Pencil /> : <Plus />}
      onClick={() => setIsOpen(true)}
    />
  );

  return (
    <>
      {button}
      <UpsertVendor
        isOpen={isOpen}
        onClose={onClose}
        jobId={jobId}
        projectId={projectId}
        vendor={vendor}
      />
    </>
  );
};
